const ArrowRight = ({ className }: { className?: string }) => {
    return (
        <div>
            <svg className={className} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3809 26.5599L21.0742 17.8666C22.1009 16.8399 22.1009 15.1599 21.0742 14.1333L12.3809 5.43994"
                    stroke="white"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export default ArrowRight;
